export const dangerTextOnDark = '#ff8a7a';

export const touchActionBarButtonHeight = 60;
export const mobileGutter = 10;
export const mobileTitleSize = 22;
export const appBarHeight = 56;
export const sheetRadius = 20;
export const sheetScrimColor = 'rgba(0, 0, 0, 0.6)';
export const stickyBarBg = '#101820';
